import { createContext } from 'react'
import type { ClientUserPreferences } from '../types/schema'

export const DEFAULT_CLIENT_USER_PREFERENCES: ClientUserPreferences = {
  theme: 'MOSAIC_LIGHT',
  memberAppTheme: null,
  animationProfile: 'FLUID',
  statusMarkers: 'SHORT',
  loadingStyle: 'CONSTELLATION',
  canvasBackground: 'DEFAULT',
  focusSoundscape: 'SILENCE',
  soundEnabled: true,
  hapticEnabled: true,
  highFidelityEffectsEnabled: false,
  watchdogLeaseTimeoutMinutes: 5,
  railCollapsedShowLabels: true,
  railAutoPopupOnHover: false,
  aiMagicRequireQuickAnswerSubmit: true,
  aiMagicDraftReadyNotifications: true,
  aiMagicAutoOpenManageDrafts: false,
  enableCelebration: true,
  enableDebugMode: false,
  supportTicketLastSeenAt: '',
  collapsingHeaderEnabled: true,
  digestCadence: 'WEEKLY',
  quietHours: null,
}

export interface ClientPreferencesContextValue {
  preferences: ClientUserPreferences
  isMobileViewport: boolean
  updatePreferences: (patch: Partial<ClientUserPreferences>) => void
  resetPreferences: () => void
  accountLookMove: 'unknown' | 'pending' | 'done'
  completeAccountLookMove: () => Promise<void>
  setFunPackThemeFallback: (active: boolean) => void
}

export const ClientPreferencesContext = createContext<ClientPreferencesContextValue | undefined>(undefined)
export { isLightTheme } from '../utils/mosaicMove'
